import "./App.css";
import { Suspense, lazy } from "react";
import Layout from "./components/Layout";
import LandingPage from "./components/LandingPage";
import CloudinaryInfiniteScroll from "./components/CloudinaryInfiniteScroll";
import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Loader from "./components/Loader";
import { EditorProvider } from "./EditorContext";

function App() {
  const queryClient = new QueryClient();
  const MemeImg = lazy(() => import("./components/MemeImg"));
  const OwnTemplate = lazy(() => import("./components/OwnTemplate"));
  
  return (
    <div className="appjs">
      <Layout>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/select-meme-template" element={<CloudinaryInfiniteScroll/>} />
            <Route path="/template/:pinId" element={<Suspense fallback={<Loader />}><EditorProvider><MemeImg /></EditorProvider></Suspense>} />
            <Route path="/use-own-template" element={<Suspense fallback={<Loader/>}><EditorProvider><OwnTemplate/></EditorProvider></Suspense>} />
          </Routes>
        </QueryClientProvider>
      </Layout>
    </div>
  );
}

export default App;
